import { initialState } from "./state"

export default {
  setType: (state, payload) => (state.type = payload),
  setDocument: (state, payload) => (state.document = payload),
  setRG: (state, payload) => (state.rg = payload),
  setGeneralRegistrationExempt: (state, payload) =>
    (state.generalRegistrationExempt = payload),
  setName: (state, payload) => (state.name = payload),
  setBirthDate: (state, payload) => (state.birthDate = payload),
  setMotherName: (state, payload) => (state.motherName = payload),
  setFatherName: (state, payload) => (state.fatherName = payload),
  setGender: (state, payload) => (state.gender = payload),
  setSchooled: (state, payload) => (state.schooled = payload),
  setMaritalStatus: (state, payload) => (state.maritalStatus = payload),
  setProfession: (state, payload) => (state.profession = payload),
  setProfessionName: (state, payload) => (state.professionName = payload),
  setContactType: (state, payload) => (state.contactType = payload),

  setCompanyName: (state, payload) => (state.companyName = payload),
  setCompanyType: (state, payload) => (state.companyType = payload),
  setCompanyState: (state, payload) => (state.companyState = payload),
  setStateId: (state, payload) => (state.stateId = payload),
  setOpeningDate: (state, payload) => (state.openingDate = payload),
  setResponsibleName: (state, payload) => (state.responsible.name = payload),
  setResponsibleCpf: (state, payload) => (state.responsible.cpf = payload),
  setState: (state, payload) => (state.state = payload),
  setStateRegistration: (state, payload) => (state.stateRegistration = payload),
  setExempt: (state, payload) => (state.exempt = payload),
  setContactName: (state, payload) => (state.contactName = payload),

  setEmail: (state, payload) => (state.email = payload),
  setCellphone: (state, payload) => (state.cellphone = payload),
  setLandline: (state, payload) => (state.landline = payload),
  setAnotherContact: (state, payload) => (state.anotherContact = payload),
  setWhatsappContact: (state, payload) => (state.whatsappContact = payload),
  setIsAnotherContactReturnedFilled: (state, payload) =>
    (state.isAnotherContactReturnedFilled = payload),

  updateIsSaved: (state, payload) => (state.isSaved = payload),
  updateClientId: (state, payload) => (state.clientId = payload),

  updateLegalPayload: (state, payload) => (state.legalPayload = payload),
  updateLegalResponsibles: (state, payload) => (state.legalResponsibles = payload),

  updateCompanyTypesOptions: (state, payload) => (state.companyTypesOptions = payload),
  updateIsCompanyTypeFromBepeople: (state, payload) => (state.isCompanyTypeFromBepeople = payload),
  updateIsRetroactiveCompanyType: (state, payload) => (state.isRetroactiveCompanyType = payload),
  updateIsCompanyStateFromBepeople: (state, payload) => (state.isCompanyStateFromBepeople = payload),
  setCustomerOrigin: (state, payload) => (state.customerOrigin = payload),
  resetClient: state => {
    const init_state = initialState()
    const keysToKeep = ['companyTypesOptions']
    Object.keys(state).forEach(key => {
      if(keysToKeep.includes(key)) {
        return
      }

      state[key] = init_state[key]
    })
  }
}
